"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normaliseArrayOfObjects = exports.arrayOfObjectsOrder = exports.arrayToObject = void 0;

var arrayToObject = function arrayToObject(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return array.reduce(function (obj, item) {
    obj[item[key]] = item;
    return obj;
  }, {});
};
/**
 * Returns array of ids in the same order as the input array
 * of objects
 */


exports.arrayToObject = arrayToObject;

var arrayOfObjectsOrder = function arrayOfObjectsOrder(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  // TODO: Check return type.
  var order = [];

  for (var i = 0; i < array.length; i++) {
    order.push(array[i][key]);
  }

  return order;
};

exports.arrayOfObjectsOrder = arrayOfObjectsOrder;

var normaliseArrayOfObjects = function normaliseArrayOfObjects(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return {
    byId: arrayToObject(array, key),
    order: arrayOfObjectsOrder(array, key)
  };
};

exports.normaliseArrayOfObjects = normaliseArrayOfObjects;